<template>
  <div class="mt-5 mb-7 content">
    <div class="mb-4">
      <h2 class="mb-4 d-flex justify-space-between">
        Relatório Administrativo
        <div>
          <app-modal-report-global
            type="Global"
            v-if="
              isFullAdmin ||
              (groupsConfig.relatorioGlobal && config.relatorioGlobal)
            "
          >
          </app-modal-report-global>
          <app-modal-report-global
            type="Geral"
            v-if="
              isFullAdmin ||
              (groupsConfig.relatorioGeral && config.relatorioGeral)
            "
          >
          </app-modal-report-global>
        </div>
      </h2>
      <div class="d-flex fixedRel align-center">
        <search-relatorio
          @onChange="(id) => goToRelatorio(id)"
          :relatorios="relatorios"
        ></search-relatorio>
        <v-btn
          v-if="showAdvancedQuery"
          color="primary"
          class="ml-4"
          @click="$router.push('/dashboard-administrativo2/consulta-avancada')"
        >
          Consulta Avançada
        </v-btn>
        <!-- <v-btn
          color="primary"
          class="buttonGraphic"
          @click="$router.push('/dashboard-administrativo2/graficos')"
        >
          <img
            :src="require('@/assets/icons/pizzaGraphic.png')"
            class="imageGraphic"
          />
          <span>Gráficos</span>
        </v-btn> -->
      </div>
    </div>
    <div class="d-flex">
      <div
        :style="{
          width: isGraphic ? '100%' : '350px',
        }"
      >
        <relatorio-fixo
          :relatorios="relatorioCategoria"
          :relatorio="selectedRelatorio"
          :isGraphic="isGraphic"
        ></relatorio-fixo>
      </div>
      <div class="relAdmin" v-if="!isGraphic">
        <template v-if="selectedRelatorio">
          <relatorio-filtros
            :relatorio="selectedRelatorio"
            :regional="regional"
            @filtrar="(e) => this.$refs.tabela.filtrar(e)"
            @gerarXlsx="() => this.$refs.tabela.gerarXlsx()"
          ></relatorio-filtros>
          <div
            :class="selectedRelatorio.id == 14 ? '' : 'margin'"
            style="height: 100%"
          >
            <tabela-relatorio
              ref="tabela"
              :relatorio="selectedRelatorio"
              :filtros="filtros"
              @regional="(e) => (regional = e)"
            ></tabela-relatorio>
          </div>
        </template>
        <!-- <template v-if="isGraphic">
          <graficos></graficos>
        </template> -->
      </div>
    </div>
  </div>
</template>
<script>
import RelatorioFiltros from "./filtros/relatorioFiltros";
import RelatorioFixo from "./relatorioFixo";
import { relatorios } from "../utils/relatorio";
import TabelaRelatorio from "./tabelaRelatorio.vue";
import SearchRelatorio from "./components/searchRelatorio.vue";
import Graficos from "./components/graficos.vue";
import AppModalReportGlobal from "@/modules/report/components/ModalReportGlobal";
import { mapGetters } from "vuex";

export default {
  components: {
    RelatorioFixo,
    RelatorioFiltros,
    TabelaRelatorio,
    SearchRelatorio,
    Graficos,
    AppModalReportGlobal,
  },
  computed: {
    relatorioCategoria() {
      return this.relatorios.reduce(function (rv, x) {
        (rv[x["category"]] = rv[x["category"]] || []).push(x);
        return rv;
      }, {});
    },
    relatorios() {
      var rel = relatorios
        .filter((item) => !item.isFullAdmin || this.isFullAdmin)
        .filter((item) => !item.estado || item.estado === this.$store.state.uf);

      if (!this.isFullAdmin) {
        rel = rel.filter((item) =>
          this.userRelatorios.some((user) => user === item.id)
        );
      }

      return rel;
    },
    ...mapGetters(["isFullAdmin", "user"]),
    showAdvancedQuery() {
      return (
        this.isFullAdmin &&
        this.user &&
        this.user.email === "admin@admin.com.br"
      );
    },
  },
  watch: {
    "$route.path"(path) {
      this.isGraphic = path.indexOf("graficos") > 0;
      if (this.isGraphic) this.selectedRelatorio = null;
    },
    "$route.params.relatorioRoute"(val) {
      if (val) {
        this.selectedRelatorio = relatorios.filter((item) => item.id == val)[0];
        this.isGraphic = false;
      }
    },
  },
  data() {
    return {
      regional: [],
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      selectedRelatorio: relatorios.filter(
        (item) => item.id == this.$route.params.relatorioRoute
      )[0],
      userRelatorios:
        JSON.parse(
          JSON.parse(localStorage.getItem("user")).grupo.relatorioAdm
        ) || [],
      isGraphic: this.$route.path.indexOf("graficos") > 0,
      filtros: {},
    };
  },
  methods: {
    goToRelatorio(id) {
      if (id)
        this.$router.push(
          `/dashboard-administrativo2/relatorio${id ? "/" + id : ""}`
        );
    },
  },
};
</script>

<style lang="scss">
.content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 1rem;
}
.margin {
  margin-top: auto;
}
.relAdmin {
  position: relative;
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  border: 2px solid var(--corPrimaria);
  margin-left: 1rem;
  width: calc(100% - 350px);
}

.imageGraphic {
  width: 20px;
  margin-right: 10px;
}
.buttonGraphic {
  margin-left: 10px;
}
</style>
